/* unplugin-vue-components disabled */import { render } from "./PathItem.vue?vue&type=template&id=0a749f22&ts=true"
import script from "./PathItem.vue?vue&type=script&lang=ts"
export * from "./PathItem.vue?vue&type=script&lang=ts"

import "./PathItem.vue?vue&type=style&index=0&id=0a749f22&lang=scss"

import exportComponent from "/var/static/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__